function Triangle() {
  return (
    <svg width="25" height="15" viewBox="0 0 25 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 0.40332L24.1913 14.6533H0.808657L12.5 0.40332Z" fill="white" />
    </svg>
  );
}

export default Triangle;
